import React, {useContext, useState} from 'react';
import {InsuranceContext} from "../InsuranceContext";
import RenderInput from "../../FormNew/RenderInput";
import InsuranceInput from "../InsuranceInput";
import TitleInsurance from "../TitleInsurance";
import InsuranceInputHolder from "../InsuranceInput/InsuranceInputHolder";
import {optionArray} from "../functions";
import objectDataHolder from "../../Hooks/ObjectDataHolder";

function GeneralInformation() {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData
  console.log(myData)

  const objectKey = 'overallInfo'

  const contractTypeOptions = optionArray(myData?.selectBoxData?.contractType)
  const paymentType = optionArray(myData?.selectBoxData?.paymentType)

  const contractType = myData.sendData[objectKey].contractType


  const functionAfterSelectOrganization = (obj) => {


  }
  const functionAfterSelectContract = (obj) => {


  }


  const functionAfterSelectCustomerOrganization = (response) => {


    const sendData = {...myData.sendData}
    //  ما اینجا یه وابستگی داریم اگه نوع قرار داد سازمانی بود
    // باید دو تا آرلوکاپ دیده بشن آرلوکاپ مشتری و آرلوکاپ  قرار داد
    //و آرلوکاپ قرار داد یه وابستگی به نتیجه ی جواب آرلوکاپ انتخاب سازمان داره
    // که اینجا دارم اون وابستگی رو توی کلید  ذخیره میکنم
    // در صورتی که نتیجه ی آرلوکاپ مشتری  اطلاعات سازمانب اومد باید آرلوکاپ قرار داد ظاهر بشه. و اینجا مشخصش میکنم

    sendData[objectKey]['customerId'] = response['na_66'] ? response['na_66'] : ""
    sendData[objectKey]['customerName'] = response['na_67'] ? response['na_67'] : ""
    sendData[objectKey]['organizationId'] = response['na_68'] ? response['na_68'] : ""
    sendData[objectKey]['organizationName'] = response['na_69'] ? response['na_69'] : ""

    // اگه دیتای سازمانی اومده بود. باید آرلوکاپ  انتخاب  قرارا داد ظاهر بشه
    if (response['na_68']) {

      sendData[objectKey]['showContractRLookUp'] = true;
      sendData[objectKey]['depContractRLookup'] = JSON.stringify({na_68:response['na_68']});

    }

    setMyData({sendData})


  }

  const functionAfterSelectInsuranceType =(response)=>{
    const sendData = {...myData.sendData}

    sendData[objectKey]['insuranceTypeId'] = response['na_73'] ? response['na_73'] : ""
    sendData[objectKey]['insuranceTypeName'] = response['na_74'] ? response['na_74'] : ""
    sendData['financial']['depAgentRLookup'] = JSON.stringify({na_73:response['na_73']});


    setMyData({sendData})
  }


  return (<div>
    <TitleInsurance title={'اطلاعات کلی'}/>
    <div className={'insurance__box border__insurance'}>

      <InsuranceInputHolder
        objectKey={objectKey}
        row={ //
          {
            title: "شماره بیمه", type: 'string', name: 'insuranceNumber', required: true,
            placeholder:"شماره بیمه را وارد کنید"

          }}
      />
      <InsuranceInputHolder
        objectKey={objectKey}
        row={ //
          {
            title: "نوع قرار داد", type: 'selectBox', name: 'contractType', required: true, options: contractTypeOptions
          }}

      />
      {contractType === 'مشتری' && <>
        <InsuranceInputHolder
          objectKey={objectKey}
          functionAfterSelect={functionAfterSelectCustomerOrganization}
          row={ //
            {
              title: "انتخاب مشتری",
              name: 'customerId',
              required: true,
              type: 'rlookup',
              rlookupId: myData?.initialData?.customerRLookUpId,//
              placeholder: "انتخاب مشتری",
            }}
        />

        {myData.sendData['overallInfo'].showContractRLookUp && <InsuranceInputHolder
          objectKey={objectKey}
          functionAfterSelect={functionAfterSelectContract}

          variables={myData.sendData[objectKey]['depContractRLookup']}
          row={ //
            {
              title: "انتخاب قرار داد",
              name: 'contractId',
              required: true,
              type: 'rlookup',
              rlookupId: myData?.initialData?.contractRLookUpId,//
              conditionFields:"yes",
            }}
        />}
      </>


      }
      {contractType === 'سازمانی' && <>

        <InsuranceInputHolder
          objectKey={objectKey}
          functionAfterSelect={functionAfterSelectCustomerOrganization}

          row={ //
            {
              title: "انتخاب سازمان",
              name: 'organizationId',
              required: true,
              type: 'rlookup',
              rlookupId: myData?.initialData?.organizationRLookUpId,//
              placeholder: "انتخاب سازمان",
            }}


        />

        <InsuranceInputHolder
          objectKey={objectKey}
          functionAfterSelect={functionAfterSelectContract}

          variables={myData.sendData[objectKey]['depContractRLookup']}
          row={ //
            {
              title: "انتخاب قرار داد",
              name: 'contractId',
              required: true,
              type: 'rlookup',
              rlookupId: myData?.initialData?.contractRLookUpId,//
              conditionFields:"na_68",
              placeholder: "انتخاب قرار داد",

            }}
        />
      </>}
      <InsuranceInputHolder
        functionAfterSelect={functionAfterSelectInsuranceType}

        objectKey={objectKey}
        row={ //
          {
            title: "انتخاب نوع بیمه",
            name: 'insuranceTypeId',
            required: true,
            type: 'rlookup',
            rlookupId: myData?.initialData?.insuranceTypeRLookUpId,//

          }
        }
      />

      <InsuranceInputHolder
        objectKey={objectKey}
        row={ //
          {
            title: "مبلغ بیمه", type: 'price', name: 'insurancePrice', required: true,
          }}
      />
      <InsuranceInputHolder
        objectKey={objectKey}
        row={ //
          {
            title: "نوع پرداخت", //
            type: 'selectBox',//
            name: 'paymentType',//
            required: true,//
            options: paymentType,//
          }}
      />
      <InsuranceInputHolder
        objectKey={objectKey}
        row={{title: "پلاک", type: 'string', name: 'plate', required: false,}}
      />

    </div>

  </div>);
}

export default GeneralInformation;